export const formatDate = (iso) => (iso ? new Date(iso + (iso.length === 10 ? 'T00:00:00' : '')).toLocaleDateString('pt-BR') : '—');
export const formatDateTime = (iso) => (iso ? new Date(iso).toLocaleString('pt-BR') : '—');
export const todayIso = () => new Date().toISOString().slice(0, 10);
